export default __webpack_public_path__ + "static/media/LogoWhite.83ecd8c1.png";